import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Star, Truck } from "lucide-react";

const IntroSection = () => (
  <section
    data-testid="intro-section"
    className="py-20 md:py-28 bg-white"
  >
    <div className="section-container grid lg:grid-cols-12 gap-12 items-start">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="lg:col-span-7"
      >
        <div className="label-xs text-[var(--ct-primary)] mb-3">About Crosstown Movers</div>
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[var(--ct-primary)] tracking-tight leading-[1.1]"
          style={{ fontFamily: "Outfit" }}
        >
          A trusted <span className="text-[var(--ct-secondary)]">Wyoming moving company</span> built on care, experience, and {new Date().getFullYear() - 1980}+ years of local know-how.
        </h2>

        <div className="mt-7 space-y-5 text-[var(--ct-text-muted)] leading-relaxed text-[17px]">
          <p>
            Crosstown Movers is a family-owned <strong>Wyoming moving company</strong> serving
            Casper, Mills, Cheyenne, Laramie, and the surrounding Wyoming areas since 1980.
            From a quick local move across town to long-distance relocations across the
            state, our experienced crews handle every job with the same respect, speed,
            and attention to detail we'd expect for our own homes.
          </p>
          <p>
            We've earned a 4.5-star rating across 60+ reviews because we focus on what
            matters: showing up on time, protecting your floors and furniture, and giving
            you a clear, upfront price — no surprises. Whether you need <strong>local moving
            services in Wyoming</strong>, professional <strong>movers in Cheyenne</strong>, or
            reliable <strong>long-distance movers</strong> for an out-of-state relocation, our
            team has the equipment, the muscle, and the local expertise to make it
            stress-free.
          </p>
          <p>
            Open 24 hours, fully licensed and insured, and proud to call Wyoming home —
            Crosstown Movers is the partner thousands of families and businesses across
            the state have trusted to get them moved, settled, and back to life.
          </p>
        </div>
      </motion.div>

      {/* Trust pillars */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="lg:col-span-5 grid sm:grid-cols-1 gap-4"
      >
        {[
          {
            icon: <ShieldCheck className="w-6 h-6" />,
            title: "Licensed & Insured",
            text: "Full coverage on every move — your home, our equipment, your belongings.",
          },
          {
            icon: <Star className="w-6 h-6 fill-current" />,
            title: "4.5★ from 60+ Wyoming customers",
            text: "Real reviews from real movers in Casper, Cheyenne, Laramie, and beyond.",
          },
          {
            icon: <Truck className="w-6 h-6" />,
            title: "Local + Long-Distance",
            text: "Across town or across the state — one trusted Wyoming crew, start to finish.",
          },
        ].map((t, i) => (
          <div
            key={i}
            className="p-6 rounded-2xl bg-[var(--ct-bg)] border border-[var(--ct-border)] flex gap-4 items-start"
          >
            <div className="w-12 h-12 rounded-xl bg-[var(--ct-primary)] text-[var(--ct-secondary)] flex items-center justify-center flex-shrink-0">
              {t.icon}
            </div>
            <div>
              <h3
                className="text-lg font-semibold text-[var(--ct-primary)]"
                style={{ fontFamily: "Outfit" }}
              >
                {t.title}
              </h3>
              <p className="mt-1 text-sm text-[var(--ct-text-muted)] leading-relaxed">
                {t.text}
              </p>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default IntroSection;
